const DEFAULT_SCOPE = 'default';

function registerScopeFunction(fn, scopeName = DEFAULT_SCOPE) {
  if(typeof fn !== 'function') {
    throw new Error('Scope function must be a function!');
  }
  if(typeof window?.seltmannScopeList === 'undefined') {
    window.seltmannScopeList = {};
  }
  if(typeof window.seltmannScopeList[scopeName] === 'undefined') {
    window.seltmannScopeList[scopeName] = [];
  }
  if(window.seltmannScopeList[scopeName].indexOf(fn) === -1) {
    window.seltmannScopeList[scopeName].push(fn);
  }
}

function applyFunctionsToScope(scopeDomNode, scopeName = DEFAULT_SCOPE) {
  console.debug(`[scope.js] applying scope list (name: ${scopeName})`, window.seltmannScopeList[scopeName]);
  if(typeof window.seltmannScopeList[scopeName] === "undefined") {
    return;
  }
  for (const scopeFn of window.seltmannScopeList[scopeName]) {
    try {
      scopeFn(scopeDomNode);
    } catch(e) {
      console.error(`[scope.js] error applying scope function "${scopeFn.name}"`, e);
    }
  }
}

export {registerScopeFunction, applyFunctionsToScope};
